import React, { useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useHistory } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import { partnerService } from "../../Services/partner.service";
import ListAdminButtons from "../Common/ListAdminButtons";
import ResultModal from "../Common/ResultModal";
import { useTranslation } from "react-i18next";
import DeleteModal from "../Partners/DeleteModal";
import SpinnerLoading from "../Common/SpinnerLoading";

const Index = () => {
  const { t: translator } = useTranslation();
  const [partners, setPartners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });
  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });
  const [update, setUpdate] = useState(new Date());
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchName, setSearchName] = useState("");
  const history = useHistory();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    partnerService
      .get({
        searchName,
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      })
      .then((res) => {
        setIsLoading(false);
        setPartners(res.data.partners);
        setPagination({ ...pagination, totalCount: res.data.totalCount });
      })
      .catch((err) => {
        console.error(err.response);
      });
  }, [update, searchName]);

  const handleToAdd = () => {
    history.push("/addpartner");
  };

  const handleClose = () => {
    setModal({ show: false });
    history.push("/partners");
  };

  const handleToUpdate = () => {
    if (selectedItems.length !== 1) return false;
    history.push(`/update-partner/${selectedItems}`);
  };

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedItems([...selectedItems, row.partnerGuid]);
    } else {
      setSelectedItems(selectedItems.filter((p) => p !== row.partnerGuid));
    }
  };

  const handleOnSelectAll = (isSelect, rows) => {
    if (isSelect) {
      setSelectedItems(partners.map((x) => x.partnerGuid));
    } else {
      setSelectedItems([]);
    }
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (e.target.cellIndex) {
        history.push(`/update-partner/${row.partnerGuid}`);
      }
    },
  };

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    style: { backgroundColor: "rgb(248, 248, 248)" },
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            checked={selectedItems.find((x) => x === row.partnerGuid)}
            onChange={(e) => handleOnSelect(row, e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  function actionHeaderFormatter(cell, rows) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            checked={
              partners &&
              partners.length > 0 &&
              !partners
                .map((p) => p.partnerGuid)
                .some((p) => selectedItems.indexOf(p) < 0)
            }
            onChange={(e) => handleOnSelectAll(e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        remote
        keyField="partnerGuid"
        data={data}
        columns={columns}
        rowEvents={rowEvents}
        noDataIndication={translator("No-Data")}
        rowClasses="boostrap-table-row"
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  const columns = [
    {
      dataField: "partnerGuid",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      headerFormatter: actionHeaderFormatter,
      formatter: actionFormatter,
    },
    {
      dataField: "name",
      text: translator("Partners-PartnersTab-TableHeader-Name"),
    },
    {
      dataField: "street",
      text: translator("Partners-PartnersTab-TableHeader-Street"),
    },
    {
      dataField: "taxNumber",
      text: translator("Partners-PartnersTab-TableHeader-TaxNumber"),
    },
    {
      dataField: "phone",
      text: translator("Partners-PartnersTab-TableHeader-PhoneNumber"),
    },
  ];

  const addPartner = () => {
    history.push("/addpartner");
  };

  const handleHideDeleteModal = () => setShowDeleteModal(false);

  const confirmDelete = () => {
    let deletePromises = [];

    selectedItems.forEach((x) => {
      deletePromises.push(partnerService.deletePartner(x));
    });

    Promise.all(deletePromises)
      .then((data) => {
        setShowDeleteModal(false);
        setModal({
          ...modal,
          title: translator("Partners-PartnersTab-SuccesDeleteModal-Title"),
          text: translator("Partners-PartnersTab-SuccesDeleteModal-Text"),
          show: true,
          btnClass: "btn btn-primary",
        });
        setUpdate(new Date());
      })
      .catch((err) =>
        setModal({
          ...modal,
          title: translator("Partners-PartnersTab-UnsuccesDeleteModal-Title"),
          text: translator("Partners-PartnersTab-UnsuccesDeleteModal-Text"),
          show: true,
          btnClass: "btn btn-primary",
        })
      );
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("Partners-Subtitle-PartnersView")}</span>
          <button className="btn btn-primary float-right" onClick={addPartner}>
            <span
              className="icon icon-cancel web-hidden"
              style={{ transform: "rotate(45deg)" }}
            ></span>
            {translator("Partners-AddPartner")}
          </button>
        </div>
        <div className="card-body">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Partners-Filters")}
            </legend>
            <form className="row">
              <div className="form-group col-lg-2">
                <label>{translator("Partners-FiltersName")}</label>
                <input
                  type="text"
                  className="form-control"
                  value={searchName}
                  onChange={(event) => {
                    setSearchName(event.target.value);
                    setPagination({ ...pagination, pageIndex: 0 });
                  }}
                />
              </div>
            </form>
          </fieldset>
          <ListAdminButtons
            selectedItemsLength={selectedItems.length}
            handleToUpdate={handleToUpdate}
            handleDelete={() => setShowDeleteModal(true)}
          />
          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={partners}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}
        </div>
      </div>

      <DeleteModal
        show={showDeleteModal}
        handleHide={handleHideDeleteModal}
        title={translator("Partner-DeleteModal-Title")}
        text={translator("Partner-DeleteModal-Text")}
        confirmDelete={confirmDelete}
      />
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </div>
  );
};

export default Index;
